"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNormalizedDeletedState = getNormalizedDeletedState;
exports["default"] = void 0;

var _getUnifiedData = _interopRequireDefault(require("./getUnifiedData"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getNormalizedDeletedState(state, patch, config) {
  var getDatumIdValue = config.getDatumIdValue || _utils.getDefaultDatumIdValue;
  var nextState = config.nextState || {};
  Object.keys(patch).forEach(function (patchKey) {
    var data = patch[patchKey];

    if (!data) {
      return;
    }

    var nextData = (0, _getUnifiedData["default"])(data, config);
    var previousData = state[patchKey];

    if (!previousData) {
      nextState[patchKey] = nextData;
      return;
    }

    var nextDataIds = nextData.map(getDatumIdValue);
    var resolvedData = previousData.filter(function (previousDatum) {
      return !nextDataIds.includes(getDatumIdValue(previousDatum));
    });
    nextState[patchKey] = resolvedData;
  });
  return nextState;
}

var _default = getNormalizedDeletedState;
exports["default"] = _default;